<template>
<v-dialog v-model="show" persistent :max-width="$vuetify.breakpoint.smAndDown ? '' : dialogWidth" scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on">
    </slot>
  </template>
  <template v-if="customer_id">
    <Addresses v-if="request && request === 'Addresses'" :customer_id="customer_id" :title="name">
      <template v-slot:title_actions>
        <v-spacer></v-spacer>
        <v-slider label="Adjust Dialog Width" v-model="dialogWidth" min="800" :max="windowWidth" style="min-width:400px; max-width:100px"></v-slider>
        <v-spacer></v-spacer>
        <v-btn @click="show = false" icon><v-icon>mdi-close</v-icon></v-btn>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" @click="show = false" :to="`/directory_v2/${customer_id}`" tile block depressed>Go to Directory</v-btn>
      </template>
    </Addresses>
    <Contacts v-else-if="request && request === 'Contacts'" :customer_id="customer_id" :title="name">
      <template v-slot:title_actions>
        <v-spacer></v-spacer>
        <v-slider label="Adjust Dialog Width" v-model="dialogWidth" min="800" :max="windowWidth" style="min-width:400px; max-width:100px"></v-slider>
        <v-spacer></v-spacer>
        <v-btn @click="show = false" icon><v-icon>mdi-close</v-icon></v-btn>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" @click="show = false" :to="`/directory_v2/${customer_id}`" tile block depressed>Go to Directory</v-btn>
      </template>
    </Contacts>
    <Contract v-else-if="request && request === 'Contract'" :customer_id="customer_id" :title="name">
      <template v-slot:title_actions>
        <v-spacer></v-spacer>
        <v-slider label="Adjust Dialog Width" v-model="dialogWidth" min="800" :max="windowWidth" style="min-width:400px; max-width:100px"></v-slider>
        <v-spacer></v-spacer>
        <v-btn @click="show = false" icon><v-icon>mdi-close</v-icon></v-btn>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" @click="show = false" :to="`/directory_v2/${customer_id}`" tile block depressed>Go to Directory</v-btn>
      </template>
    </Contract>
    <Environment v-else-if="request && request === 'Environment'" :customer_id="customer_id" :title="name">
      <template v-slot:title_actions>
        <v-spacer></v-spacer>
        <v-slider label="Adjust Dialog Width" v-model="dialogWidth" min="800" :max="windowWidth" style="min-width:400px; max-width:100px"></v-slider>
        <v-spacer></v-spacer>
        <v-btn @click="show = false" icon><v-icon>mdi-close</v-icon></v-btn>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" @click="show = false" :to="`/directory_v2/${customer_id}`" tile block depressed>Go to Directory</v-btn>
      </template>
    </Environment>
    <Imperatives v-else-if="request && request === 'Imperatives'" :customer_id="customer_id" :title="name" dialog>
      <template v-slot:title_actions>
        <v-spacer></v-spacer>
        <v-slider label="Adjust Dialog Width" v-model="dialogWidth" min="800" :max="windowWidth" style="min-width:400px; max-width:100px"></v-slider>
        <v-spacer></v-spacer>
        <v-btn @click="show = false" icon><v-icon>mdi-close</v-icon></v-btn>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" @click="show = false" :to="`/directory_v2/${customer_id}`" tile block depressed>Go to Directory</v-btn>
      </template>
    </Imperatives>
    <Licenses v-else-if="request && request === 'Licenses'" :customer_id="customer_id" :title="name" dialog>
      <template v-slot:title_actions>
        <v-spacer></v-spacer>
        <v-slider label="Adjust Dialog Width" v-model="dialogWidth" min="800" :max="windowWidth" style="min-width:400px; max-width:100px"></v-slider>
        <v-spacer></v-spacer>
        <v-btn @click="show = false" icon><v-icon>mdi-close</v-icon></v-btn>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" @click="show = false" :to="`/directory_v2/${customer_id}`" tile block depressed>Go to Directory</v-btn>
      </template>
    </Licenses>
    <Names v-else-if="request && request === 'Names'" :customer_id="customer_id" :title="name" dialog>
      <template v-slot:title_actions>
        <v-spacer></v-spacer>
        <v-slider label="Adjust Dialog Width" v-model="dialogWidth" min="800" :max="windowWidth" style="min-width:400px; max-width:100px"></v-slider>
        <v-spacer></v-spacer>
        <v-btn @click="show = false" icon><v-icon>mdi-close</v-icon></v-btn>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" @click="show = false" :to="`/directory_v2/${customer_id}`" tile block depressed>Go to Directory</v-btn>
      </template>
    </Names>
    <Notes v-else-if="request && request === 'Notes'" :customer_id="customer_id" :title="name">
      <template v-slot:title_actions>
        <v-spacer></v-spacer>
        <v-slider label="Adjust Dialog Width" v-model="dialogWidth" min="800" :max="windowWidth" style="min-width:400px; max-width:100px"></v-slider>
        <v-spacer></v-spacer>
        <v-btn @click="show = false" icon><v-icon>mdi-close</v-icon></v-btn>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" @click="show = false" :to="`/directory_v2/${customer_id}`" tile block depressed>Go to Directory</v-btn>
      </template>
    </Notes>
    <Samples v-else-if="request && request === 'Samples'"  :customer_id="customer_id" :title="name">
      <template v-slot:title_actions>
        <v-spacer></v-spacer>
        <v-slider label="Adjust Dialog Width" v-model="dialogWidth" min="800" :max="windowWidth" style="min-width:400px; max-width:100px"></v-slider>
        <v-spacer></v-spacer>
        <v-btn @click="show = false" icon><v-icon>mdi-close</v-icon></v-btn>
      </template>
      <template v-slot:actions>
        <v-btn color="primary" @click="show = false" :to="`/directory_v2/${customer_id}`" tile block depressed>Go to Directory</v-btn>
      </template>
    </Samples>
  </template>
</v-dialog>
</template>

<script>
export default {
name: "IndividualDialogs",
  components:{
    Addresses: () => import('./Addresses'),
    Contacts: () => import('./Contacts'),
    Contract: () => import('./Contract'),
    Environment: () => import('./Environment'),
    Imperatives: () => import('./Imperatives'),
    Licenses: () => import('./Licenses'),
    Names: () => import('./Names'),
    Notes: () => import('./Notes'),
    Samples: () => import("@/views/DirectoryV2/components/Samples")
  },
  props:{
    customer_id: {
      required: false,
    },
    name: {
      required: false,
    },
    request:{
      required: false
    }
  },
  computed:{
    windowWidth(){
      return window.innerWidth
    },
    dialogWidth(){
      if(this.request && this.request === 'Samples'){
        return this.windowWidth;
      }
      return 800
    }
  },
  data: () => ({
    show: false,
  })
}
</script>

<style scoped>

</style>
